import styled from "styled-components";

export const ItineraryContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px 24px;
  margin-bottom: 20px;
`;

export const Separator = styled.div`
  width: 1px;
  height: 20px;
  background-color: #d1d5db;
  flex-shrink: 0;
`;
